import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import logo from "../assets/Provinyx-logo-w.png";

/* Only what Tailwind utilities can't express: font import, keyframes, reduced-motion. */
const SP_CSS = `
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');
@keyframes sp-rise{from{opacity:0;transform:translateY(18px)}}
@keyframes sp-fill{from{width:0}}
@keyframes sp-ripple{to{transform:scale(4);opacity:0;border-width:1px}}
@keyframes sp-fade{from{opacity:0}}
.sp-fade{animation:sp-fade .25s ease}
.sp-rise{animation:sp-rise .45s cubic-bezier(.16,1,.3,1)}
.sp-li{animation:sp-rise .4s cubic-bezier(.16,1,.3,1) both}
.sp-fill{animation:sp-fill .7s .35s cubic-bezier(.65,0,.35,1) both}
.sp-ripple{animation:sp-ripple .5s ease-out forwards}
@media (prefers-reduced-motion:reduce){.sp-root *{transition:none!important;animation:none!important}}
`;

/* ── Icons ───────────────────────────────────────────────────────────────── */
const PATHS = {
  globe: <><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18"/></>,
  lock: <><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></>,
  info: <><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8v.01"/></>,
  box: <><path d="M12 3l8 4.5v9L12 21l-8-4.5v-9z"/><path d="M12 12v9M4 7.5l8 4.5 8-4.5"/></>,
  leaf: <><path d="M5 19c0-8 6-13 14-14-1 8-6 14-14 14z"/><path d="M5 19l7-7"/></>,
  cycle: <><path d="M7 7l-3 5 3 5M4 12h9a4 4 0 0 0 4-4"/><path d="M17 17l3-5-3-5"/></>,
  gauge: <><path d="M3 14a9 9 0 0 1 18 0"/><path d="M12 14l4-3"/><path d="M3 18h18"/></>,
  shield: <><path d="M9 12l2 2 4-4"/><path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6z"/></>,
  bin: <path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/>,
  clock: <><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></>,
  list: <path d="M4 6h16M4 12h16M4 18h10"/>,
  wrench: <path d="M14 4l6 6-9 9H5v-6z"/>,
  warn: <><path d="M12 3l9 16H3z"/><path d="M12 10v4M12 17v.01"/></>,
  doc: <><path d="M7 3h7l5 5v13H7z"/><path d="M14 3v5h5"/></>,
  checkc: <><path d="M9 12l2 2 4-4"/><circle cx="12" cy="12" r="9"/></>,
  x: <path d="M6 6l12 12M18 6L6 18"/>,
};
const Ic = ({ n, className = "" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {PATHS[n]}
  </svg>
);

/* ── Static QR (same pattern as the original sample) ─────────────────────── */
const QR_PATH = "M0 0h1.02v1.02h-1.02zM1 0h1.02v1.02h-1.02zM2 0h1.02v1.02h-1.02zM3 0h1.02v1.02h-1.02zM4 0h1.02v1.02h-1.02zM5 0h1.02v1.02h-1.02zM6 0h1.02v1.02h-1.02zM8 0h1.02v1.02h-1.02zM9 0h1.02v1.02h-1.02zM11 0h1.02v1.02h-1.02zM12 0h1.02v1.02h-1.02zM13 0h1.02v1.02h-1.02zM14 0h1.02v1.02h-1.02zM18 0h1.02v1.02h-1.02zM19 0h1.02v1.02h-1.02zM20 0h1.02v1.02h-1.02zM21 0h1.02v1.02h-1.02zM22 0h1.02v1.02h-1.02zM23 0h1.02v1.02h-1.02zM24 0h1.02v1.02h-1.02zM0 1h1.02v1.02h-1.02zM6 1h1.02v1.02h-1.02zM8 1h1.02v1.02h-1.02zM10 1h1.02v1.02h-1.02zM11 1h1.02v1.02h-1.02zM14 1h1.02v1.02h-1.02zM18 1h1.02v1.02h-1.02zM24 1h1.02v1.02h-1.02zM0 2h1.02v1.02h-1.02zM2 2h1.02v1.02h-1.02zM3 2h1.02v1.02h-1.02zM4 2h1.02v1.02h-1.02zM6 2h1.02v1.02h-1.02zM8 2h1.02v1.02h-1.02zM9 2h1.02v1.02h-1.02zM10 2h1.02v1.02h-1.02zM13 2h1.02v1.02h-1.02zM14 2h1.02v1.02h-1.02zM18 2h1.02v1.02h-1.02zM20 2h1.02v1.02h-1.02zM21 2h1.02v1.02h-1.02zM22 2h1.02v1.02h-1.02zM24 2h1.02v1.02h-1.02zM0 3h1.02v1.02h-1.02zM2 3h1.02v1.02h-1.02zM3 3h1.02v1.02h-1.02zM4 3h1.02v1.02h-1.02zM6 3h1.02v1.02h-1.02zM9 3h1.02v1.02h-1.02zM10 3h1.02v1.02h-1.02zM11 3h1.02v1.02h-1.02zM12 3h1.02v1.02h-1.02zM13 3h1.02v1.02h-1.02zM15 3h1.02v1.02h-1.02zM16 3h1.02v1.02h-1.02zM18 3h1.02v1.02h-1.02zM20 3h1.02v1.02h-1.02zM21 3h1.02v1.02h-1.02zM22 3h1.02v1.02h-1.02zM24 3h1.02v1.02h-1.02zM0 4h1.02v1.02h-1.02zM2 4h1.02v1.02h-1.02zM3 4h1.02v1.02h-1.02zM4 4h1.02v1.02h-1.02zM6 4h1.02v1.02h-1.02zM8 4h1.02v1.02h-1.02zM11 4h1.02v1.02h-1.02zM13 4h1.02v1.02h-1.02zM14 4h1.02v1.02h-1.02zM18 4h1.02v1.02h-1.02zM20 4h1.02v1.02h-1.02zM21 4h1.02v1.02h-1.02zM22 4h1.02v1.02h-1.02zM24 4h1.02v1.02h-1.02zM0 5h1.02v1.02h-1.02zM6 5h1.02v1.02h-1.02zM10 5h1.02v1.02h-1.02zM11 5h1.02v1.02h-1.02zM12 5h1.02v1.02h-1.02zM13 5h1.02v1.02h-1.02zM14 5h1.02v1.02h-1.02zM16 5h1.02v1.02h-1.02zM18 5h1.02v1.02h-1.02zM24 5h1.02v1.02h-1.02zM0 6h1.02v1.02h-1.02zM1 6h1.02v1.02h-1.02zM2 6h1.02v1.02h-1.02zM3 6h1.02v1.02h-1.02zM4 6h1.02v1.02h-1.02zM5 6h1.02v1.02h-1.02zM6 6h1.02v1.02h-1.02zM8 6h1.02v1.02h-1.02zM10 6h1.02v1.02h-1.02zM12 6h1.02v1.02h-1.02zM14 6h1.02v1.02h-1.02zM16 6h1.02v1.02h-1.02zM18 6h1.02v1.02h-1.02zM19 6h1.02v1.02h-1.02zM20 6h1.02v1.02h-1.02zM21 6h1.02v1.02h-1.02zM22 6h1.02v1.02h-1.02zM23 6h1.02v1.02h-1.02zM24 6h1.02v1.02h-1.02zM11 7h1.02v1.02h-1.02zM13 7h1.02v1.02h-1.02zM0 8h1.02v1.02h-1.02zM3 8h1.02v1.02h-1.02zM4 8h1.02v1.02h-1.02zM5 8h1.02v1.02h-1.02zM6 8h1.02v1.02h-1.02zM7 8h1.02v1.02h-1.02zM8 8h1.02v1.02h-1.02zM9 8h1.02v1.02h-1.02zM12 8h1.02v1.02h-1.02zM14 8h1.02v1.02h-1.02zM17 8h1.02v1.02h-1.02zM20 8h1.02v1.02h-1.02zM22 8h1.02v1.02h-1.02zM23 8h1.02v1.02h-1.02zM24 8h1.02v1.02h-1.02zM1 9h1.02v1.02h-1.02zM2 9h1.02v1.02h-1.02zM5 9h1.02v1.02h-1.02zM7 9h1.02v1.02h-1.02zM10 9h1.02v1.02h-1.02zM11 9h1.02v1.02h-1.02zM13 9h1.02v1.02h-1.02zM14 9h1.02v1.02h-1.02zM15 9h1.02v1.02h-1.02zM17 9h1.02v1.02h-1.02zM19 9h1.02v1.02h-1.02zM20 9h1.02v1.02h-1.02zM21 9h1.02v1.02h-1.02zM22 9h1.02v1.02h-1.02zM23 9h1.02v1.02h-1.02zM0 10h1.02v1.02h-1.02zM2 10h1.02v1.02h-1.02zM4 10h1.02v1.02h-1.02zM6 10h1.02v1.02h-1.02zM7 10h1.02v1.02h-1.02zM8 10h1.02v1.02h-1.02zM9 10h1.02v1.02h-1.02zM11 10h1.02v1.02h-1.02zM12 10h1.02v1.02h-1.02zM15 10h1.02v1.02h-1.02zM16 10h1.02v1.02h-1.02zM17 10h1.02v1.02h-1.02zM18 10h1.02v1.02h-1.02zM20 10h1.02v1.02h-1.02zM21 10h1.02v1.02h-1.02zM24 10h1.02v1.02h-1.02zM0 11h1.02v1.02h-1.02zM1 11h1.02v1.02h-1.02zM5 11h1.02v1.02h-1.02zM7 11h1.02v1.02h-1.02zM8 11h1.02v1.02h-1.02zM10 11h1.02v1.02h-1.02zM12 11h1.02v1.02h-1.02zM14 11h1.02v1.02h-1.02zM16 11h1.02v1.02h-1.02zM17 11h1.02v1.02h-1.02zM21 11h1.02v1.02h-1.02zM22 11h1.02v1.02h-1.02zM23 11h1.02v1.02h-1.02zM24 11h1.02v1.02h-1.02zM1 12h1.02v1.02h-1.02zM5 12h1.02v1.02h-1.02zM6 12h1.02v1.02h-1.02zM7 12h1.02v1.02h-1.02zM8 12h1.02v1.02h-1.02zM10 12h1.02v1.02h-1.02zM11 12h1.02v1.02h-1.02zM13 12h1.02v1.02h-1.02zM14 12h1.02v1.02h-1.02zM18 12h1.02v1.02h-1.02zM24 12h1.02v1.02h-1.02zM0 13h1.02v1.02h-1.02zM2 13h1.02v1.02h-1.02zM4 13h1.02v1.02h-1.02zM5 13h1.02v1.02h-1.02zM7 13h1.02v1.02h-1.02zM9 13h1.02v1.02h-1.02zM12 13h1.02v1.02h-1.02zM14 13h1.02v1.02h-1.02zM15 13h1.02v1.02h-1.02zM16 13h1.02v1.02h-1.02zM20 13h1.02v1.02h-1.02zM23 13h1.02v1.02h-1.02zM0 14h1.02v1.02h-1.02zM1 14h1.02v1.02h-1.02zM2 14h1.02v1.02h-1.02zM4 14h1.02v1.02h-1.02zM6 14h1.02v1.02h-1.02zM8 14h1.02v1.02h-1.02zM14 14h1.02v1.02h-1.02zM15 14h1.02v1.02h-1.02zM16 14h1.02v1.02h-1.02zM17 14h1.02v1.02h-1.02zM20 14h1.02v1.02h-1.02zM21 14h1.02v1.02h-1.02zM22 14h1.02v1.02h-1.02zM23 14h1.02v1.02h-1.02zM24 14h1.02v1.02h-1.02zM0 15h1.02v1.02h-1.02zM7 15h1.02v1.02h-1.02zM8 15h1.02v1.02h-1.02zM12 15h1.02v1.02h-1.02zM13 15h1.02v1.02h-1.02zM14 15h1.02v1.02h-1.02zM15 15h1.02v1.02h-1.02zM17 15h1.02v1.02h-1.02zM19 15h1.02v1.02h-1.02zM21 15h1.02v1.02h-1.02zM22 15h1.02v1.02h-1.02zM24 15h1.02v1.02h-1.02zM0 16h1.02v1.02h-1.02zM2 16h1.02v1.02h-1.02zM3 16h1.02v1.02h-1.02zM5 16h1.02v1.02h-1.02zM6 16h1.02v1.02h-1.02zM8 16h1.02v1.02h-1.02zM9 16h1.02v1.02h-1.02zM11 16h1.02v1.02h-1.02zM12 16h1.02v1.02h-1.02zM16 16h1.02v1.02h-1.02zM17 16h1.02v1.02h-1.02zM18 16h1.02v1.02h-1.02zM19 16h1.02v1.02h-1.02zM20 16h1.02v1.02h-1.02zM22 16h1.02v1.02h-1.02zM23 16h1.02v1.02h-1.02zM8 17h1.02v1.02h-1.02zM10 17h1.02v1.02h-1.02zM11 17h1.02v1.02h-1.02zM16 17h1.02v1.02h-1.02zM20 17h1.02v1.02h-1.02zM22 17h1.02v1.02h-1.02zM23 17h1.02v1.02h-1.02zM0 18h1.02v1.02h-1.02zM1 18h1.02v1.02h-1.02zM2 18h1.02v1.02h-1.02zM3 18h1.02v1.02h-1.02zM4 18h1.02v1.02h-1.02zM5 18h1.02v1.02h-1.02zM6 18h1.02v1.02h-1.02zM8 18h1.02v1.02h-1.02zM9 18h1.02v1.02h-1.02zM10 18h1.02v1.02h-1.02zM12 18h1.02v1.02h-1.02zM13 18h1.02v1.02h-1.02zM14 18h1.02v1.02h-1.02zM16 18h1.02v1.02h-1.02zM18 18h1.02v1.02h-1.02zM20 18h1.02v1.02h-1.02zM24 18h1.02v1.02h-1.02zM0 19h1.02v1.02h-1.02zM6 19h1.02v1.02h-1.02zM8 19h1.02v1.02h-1.02zM11 19h1.02v1.02h-1.02zM13 19h1.02v1.02h-1.02zM15 19h1.02v1.02h-1.02zM16 19h1.02v1.02h-1.02zM20 19h1.02v1.02h-1.02zM24 19h1.02v1.02h-1.02zM0 20h1.02v1.02h-1.02zM2 20h1.02v1.02h-1.02zM3 20h1.02v1.02h-1.02zM4 20h1.02v1.02h-1.02zM6 20h1.02v1.02h-1.02zM8 20h1.02v1.02h-1.02zM11 20h1.02v1.02h-1.02zM13 20h1.02v1.02h-1.02zM15 20h1.02v1.02h-1.02zM16 20h1.02v1.02h-1.02zM17 20h1.02v1.02h-1.02zM18 20h1.02v1.02h-1.02zM19 20h1.02v1.02h-1.02zM20 20h1.02v1.02h-1.02zM23 20h1.02v1.02h-1.02zM24 20h1.02v1.02h-1.02zM0 21h1.02v1.02h-1.02zM2 21h1.02v1.02h-1.02zM3 21h1.02v1.02h-1.02zM4 21h1.02v1.02h-1.02zM6 21h1.02v1.02h-1.02zM8 21h1.02v1.02h-1.02zM10 21h1.02v1.02h-1.02zM12 21h1.02v1.02h-1.02zM13 21h1.02v1.02h-1.02zM15 21h1.02v1.02h-1.02zM16 21h1.02v1.02h-1.02zM17 21h1.02v1.02h-1.02zM18 21h1.02v1.02h-1.02zM23 21h1.02v1.02h-1.02zM24 21h1.02v1.02h-1.02zM0 22h1.02v1.02h-1.02zM2 22h1.02v1.02h-1.02zM3 22h1.02v1.02h-1.02zM4 22h1.02v1.02h-1.02zM6 22h1.02v1.02h-1.02zM10 22h1.02v1.02h-1.02zM11 22h1.02v1.02h-1.02zM13 22h1.02v1.02h-1.02zM15 22h1.02v1.02h-1.02zM16 22h1.02v1.02h-1.02zM20 22h1.02v1.02h-1.02zM21 22h1.02v1.02h-1.02zM22 22h1.02v1.02h-1.02zM23 22h1.02v1.02h-1.02zM24 22h1.02v1.02h-1.02zM0 23h1.02v1.02h-1.02zM6 23h1.02v1.02h-1.02zM9 23h1.02v1.02h-1.02zM10 23h1.02v1.02h-1.02zM11 23h1.02v1.02h-1.02zM12 23h1.02v1.02h-1.02zM13 23h1.02v1.02h-1.02zM18 23h1.02v1.02h-1.02zM19 23h1.02v1.02h-1.02zM20 23h1.02v1.02h-1.02zM22 23h1.02v1.02h-1.02zM23 23h1.02v1.02h-1.02zM24 23h1.02v1.02h-1.02zM0 24h1.02v1.02h-1.02zM1 24h1.02v1.02h-1.02zM2 24h1.02v1.02h-1.02zM3 24h1.02v1.02h-1.02zM4 24h1.02v1.02h-1.02zM5 24h1.02v1.02h-1.02zM6 24h1.02v1.02h-1.02zM8 24h1.02v1.02h-1.02zM11 24h1.02v1.02h-1.02zM12 24h1.02v1.02h-1.02zM13 24h1.02v1.02h-1.02zM16 24h1.02v1.02h-1.02zM17 24h1.02v1.02h-1.02zM21 24h1.02v1.02h-1.02zM24 24h1.02v1.02h-1.02z";

/* ── Data ────────────────────────────────────────────────────────────────── */
const FACTS = [
  ["bg-[#EEF3FF]", "Carbon footprint", "61.4", "kg CO₂e/kWh"],
  ["bg-[#F2F0FC]", "Rated capacity", "672", "Wh"],
  ["bg-[#FDF5E9]", "Recycled cobalt", "16", "%"],
  ["bg-[#ECF7F0]", "State of health", "100", "%"],
  ["bg-[#FDEEF0]", "Expected lifetime", "800", "cycles"],
];

const TABS = [
  { id: "public", label: "Everyone", icon: "globe" },
  { id: "legit", label: "Repairers & recyclers", icon: "lock" },
  { id: "auth", label: "Authorities", icon: "lock" },
];
const NOTES = [
  "The Battery Regulation splits a passport into three access levels. This is the public level — anyone who scans the battery sees it.",
  "This level is locked in a live passport. Here is what it contains.",
  "This level is locked in a live passport. Here is what it contains.",
];
const NOTE_IDLE = "Choose who is looking at the passport.";

// [label, value, lockedFlag]
const GENERAL = [
  ["Manufacturer", "NordCycle Mobility GmbH"], ["Manufacturer ID", "NCM-DE-4471023"],
  ["Model", "VRC-48V-14"], ["Serial number", "SN-48V-14AH-0039"],
  ["Place of manufacture", "Bremen, Germany"], ["Date of manufacture", "February 2027"],
  ["Placed on the EU market", "12 March 2027"], ["Weight", "2.9 kg"],
];
const MATERIALS = [
  ["Chemistry", "Lithium-ion, NMC 811"], ["Cathode", "Nickel-manganese-cobalt oxide"], ["Anode", "Graphite"],
  ["Critical raw materials", "Cobalt, lithium, nickel, natural graphite"],
  ["Hazardous substances", "Lithium hexafluorophosphate (electrolyte)"],
  ["Detailed composition", "Repairers & recyclers", true],
];
const PERFORMANCE = [
  ["Rated capacity", "14 Ah · 672 Wh"], ["Voltage (min · nominal · max)", "39 · 48 · 54.6 V"],
  ["Original power capability", "1.2 kW"], ["Expected lifetime", "800 cycles to 80% capacity"],
  ["Round-trip efficiency", "94% new · 91% at half life"], ["Operating temperature", "−10 to 45 °C"],
  ["Charge cycles so far", "0"], ["Negative events", "None recorded"],
];
const DILIGENCE = [
  ["Supply-chain due diligence report", "Published · Nov 2026"], ["Third-party verification", "Verified by a notified body"],
  ["EU declaration of conformity", "Available"], ["CE marking", "Yes"],
  ["Separate-collection label", "Crossed-out bin symbol"], ["Test reports", "Authorities", true],
];
const END_OF_LIFE = [
  ["Household waste", "Not allowed"], ["Return it to", "Any VoltRide retailer or municipal collection point"],
  ["Take-back cost", "Free of charge"], ["Dismantling & safety guidance", "Repairers & recyclers", true],
];
const STACK = [
  ["62%", "#1E3C9A", "Raw materials & pre-processing", "38.1"],
  ["29%", "#336BE1", "Cell & pack production", "17.9"],
  ["2%", "#49ADFF", "Distribution", "1.2"],
  ["7%", "#9EC9FF", "End of life & recycling", "4.2"],
];
const HISTORY = [
  ["Nov 2026", "Raw-material due diligence verified"],
  ["Feb 2027", "Manufactured in Bremen, Germany"],
  ["Mar 2027", "Passport published and battery placed on the EU market"],
  ["Mar 2027", "Registered in the EU digital product passport registry"],
  ["Sep 2027", "State of health updated — 100%"],
];
const LOCKED = [
  {
    title: "For repairers, remanufacturers and recyclers",
    who: "Visible only to people with a legitimate interest in the battery, and to the European Commission.",
    items: [
      ["box", "Detailed composition of cathode, anode and electrolyte"],
      ["list", "Part numbers and where to source spare parts"],
      ["wrench", "Dismantling instructions and exploded diagrams"],
      ["warn", "Safety measures for handling and transport"],
    ],
    how: "In a live passport, a verified professional signs in to see this level. This sample shows what the level contains, not the data itself.",
  },
  {
    title: "For notified bodies and market surveillance",
    who: "Visible only to notified bodies, market surveillance authorities and the European Commission.",
    items: [
      ["doc", "Test reports that prove the battery meets the regulation"],
      ["checkc", "Evidence behind the declared performance and durability values"],
    ],
    how: "In a live passport, only the authorities above can open this level.",
  },
];

/* ── Small building blocks ───────────────────────────────────────────────── */
const CARD = "rounded-[22px] bg-white p-5 shadow-[0_10px_32px_rgba(14,26,58,.06)]";

function SecHead({ icon, title, desc }) {
  return (
    <>
      <div className="mb-1 flex items-center gap-[11px]">
        <span className="grid h-[34px] w-[34px] flex-none place-items-center rounded-[11px] bg-[#EEF3FF] text-[#2F57E6]">
          <Ic n={icon} className="h-[18px] w-[18px]" />
        </span>
        <h2 className="text-[17px] font-bold tracking-[-.01em]">{title}</h2>
      </div>
      <p className="mb-3.5 ml-[45px] text-[12.5px] text-[#6B7590] max-[760px]:ml-0">{desc}</p>
    </>
  );
}

function Rows({ rows, className = "" }) {
  return (
    <div className={`grid grid-cols-1 ${className}`}>
      {rows.map(([k, v, locked]) => (
        <div key={k} className="flex justify-between gap-4 border-b border-dashed border-[#E6EBF4] py-[9px] text-[13.5px] last:border-b-0">
          <span className="text-[#6B7590]">{k}</span>
          {locked ? (
            <span className="inline-flex items-center gap-[5px] text-right font-medium text-[#8B93A8]">
              <Ic n="lock" className="h-[13px] w-[13px]" />{v}
            </span>
          ) : (
            <span className="text-right font-semibold tabular-nums">{v}</span>
          )}
        </div>
      ))}
    </div>
  );
}

function Bar({ label, pct, soh }) {
  return (
    <div className="mt-3">
      <div className="flex justify-between text-[13px] text-[#3A4563]">
        <span>{label}</span><b className="font-semibold tabular-nums">{pct}%</b>
      </div>
      <div className="mt-1.5 h-[9px] overflow-hidden rounded-md bg-[#F6F8FC]">
        <i className={`sp-fill block h-full rounded-md ${soh ? "bg-[#0E7A4A]" : "bg-[#2F57E6]"}`} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}

/* ── Main component ──────────────────────────────────────────────────────── */
export default function SamplePassport({ onClose }) {
  const scrollRef = useRef(null);
  const closeRef = useRef(null);
  const tabRefs = useRef([]);

  const [active, setActive] = useState(0);        // -1 = nothing chosen yet (demo reset)
  const [hoverIdx, setHoverIdx] = useState(-1);
  const [cursorOn, setCursorOn] = useState(false);
  const [press, setPress] = useState(false);
  const [pos, setPos] = useState(() =>
    typeof window === "undefined" ? { x: 0, y: 0 } : { x: window.innerWidth * 0.7, y: window.innerHeight * 0.8 }
  );
  const [ripples, setRipples] = useState([]);

  /* lock page scroll, focus the close button, restore focus on exit, Esc to close */
  useEffect(() => {
    const prevOverflow = document.body.style.overflow;
    const opener = document.activeElement;
    document.body.style.overflow = "hidden";
    closeRef.current?.focus();
    const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener("keydown", onKey);
      if (opener && opener.focus) opener.focus();
    };
  }, [onClose]);

  /* auto-play demo: cursor clicks through the three access levels, then loops.
     Stops for good as soon as the visitor clicks, scrolls, touches or presses a key. */
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    let stopped = false;
    const SCROLL = 105;
    const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
    const moveTo = (x, y) => setPos({ x: x - 2, y: y - 2 });
    const centre = (el) => { const r = el.getBoundingClientRect(); return [r.left + r.width / 2, r.top + r.height / 2]; };

    const reset = () => {
      setActive(-1); setHoverIdx(-1);
      scrollRef.current?.scrollTo({ top: 0 });
    };
    const stop = () => {
      if (stopped) return;
      stopped = true;
      setCursorOn(false); setHoverIdx(-1);
      setActive((a) => (a < 0 ? 0 : a));
    };
    const onUser = (e) => { if (e.isTrusted) stop(); };
    const evs = ["pointerdown", "wheel", "touchstart", "keydown"];
    evs.forEach((ev) => window.addEventListener(ev, onUser, { passive: true }));

    async function click(i) {
      const tab = tabRefs.current[i];
      if (!tab) return;
      const [x, y] = centre(tab);
      moveTo(x, y);
      await sleep(550); if (stopped) return;
      setHoverIdx(i);
      await sleep(250); if (stopped) return;
      setPress(true);
      const id = Math.random();
      setRipples((r) => [...r, { id, x, y }]);
      setTimeout(() => setRipples((r) => r.filter((q) => q.id !== id)), 600);
      setHoverIdx(-1);
      setActive(i);
      await sleep(120);
      setPress(false);
    }

    async function run() {
      while (!stopped) {
        reset();
        moveTo(window.innerWidth * 0.62, window.innerHeight * 0.8);
        await sleep(500); if (stopped) return;
        setCursorOn(true);
        await sleep(300); if (stopped) return;
        await click(0); if (stopped) return;
        scrollRef.current?.scrollTo({ top: SCROLL, behavior: "smooth" });
        await sleep(1500); if (stopped) return;
        await click(1); if (stopped) return;
        await sleep(1300); if (stopped) return;
        await click(2); if (stopped) return;
        await sleep(2200); if (stopped) return;
        setCursorOn(false);
        await sleep(400);
      }
    }
    const t = setTimeout(run, 300);

    return () => {
      stopped = true;
      clearTimeout(t);
      evs.forEach((ev) => window.removeEventListener(ev, onUser));
    };
  }, []);

  const onTabKey = (e, i) => {
    if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
    const next = (i + (e.key === "ArrowRight" ? 1 : TABS.length - 1)) % TABS.length;
    setActive(next);
    tabRefs.current[next]?.focus();
  };

  const focusIdx = active < 0 ? 0 : active;

  return createPortal(
    <div
      className="sp-root sp-fade fixed inset-0 z-[1000] flex items-center justify-center bg-[#0E1A3A]/45 p-3 backdrop-blur-md sm:p-6"
      style={{ fontFamily: "'Poppins',system-ui,-apple-system,'Segoe UI',sans-serif" }}
      onMouseDown={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
    >
      <style dangerouslySetInnerHTML={{ __html: SP_CSS }} />

      <div
        role="dialog"
        aria-modal="true"
        aria-label="Sample battery passport"
        className="relative h-full max-h-[920px] w-full max-w-[1100px] overflow-hidden rounded-[20px] bg-[#EEF2F9] leading-normal text-[#0E1A3A] antialiased shadow-[0_30px_80px_rgba(14,26,58,.45)]"
      >
      <div ref={scrollRef} className="h-full overflow-y-auto overscroll-contain">

      {/* top bar */}
      <header className="sticky top-0 z-30 bg-[#336BE1] px-4 text-white">
        <div className="mx-auto flex h-[62px] max-w-[1080px] items-center gap-3">
          <button
            ref={closeRef}
            type="button"
            onClick={onClose}
            aria-label="Close sample passport"
            className="grid h-9 w-9 flex-none cursor-pointer place-items-center rounded-full bg-white/15 text-white transition-colors hover:bg-white/25 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
          >
            <Ic n="x" className="h-[18px] w-[18px]" />
          </button>
          <img src={logo} alt="Provinyx" className="block h-[26px] w-auto" />
          <span className="border-l border-white/35 pl-3 text-[13px] font-medium tracking-[.04em] text-white/90 max-[760px]:hidden">
            Battery passport
          </span>
          {/* <span className="ml-auto whitespace-nowrap rounded-full bg-white px-[11px] py-1 text-[11px] font-semibold uppercase tracking-[.06em] text-[#336BE1]">
            Sample
          </span> */}
        </div>
      </header>

      <main className="mx-auto flex max-w-[1080px] flex-col gap-4 px-4 pb-10 pt-[18px]">
        {/* hero */}
        <section
          aria-label="Battery summary"
          className="grid grid-cols-[auto_1fr_auto] items-center gap-[22px] rounded-3xl bg-white p-[22px] shadow-[0_10px_32px_rgba(14,26,58,.06)] max-[760px]:grid-cols-[auto_1fr]"
        >
          <div aria-hidden="true" className="grid h-[120px] w-24 place-items-center rounded-[18px] bg-[#F6F8FC] max-[420px]:h-24 max-[420px]:w-[72px]">
            <svg viewBox="0 0 120 150" className="h-[92px] w-auto max-[420px]:h-[70px]">
              <defs>
                <linearGradient id="sp-bg" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0" stopColor="#4A70F0" /><stop offset="1" stopColor="#1E3C9A" />
                </linearGradient>
              </defs>
              <rect x="10" y="22" width="100" height="122" rx="16" fill="url(#sp-bg)" />
              <rect x="36" y="10" width="48" height="16" rx="6" fill="#1E3C9A" />
              <rect x="22" y="50" width="76" height="84" rx="10" fill="#0F2470" opacity=".5" />
              <rect x="28" y="72" width="64" height="56" rx="7" fill="#49C98E" />
              <path d="M66 58 L46 96 H60 L54 124 L78 86 H64 Z" fill="#fff" />
            </svg>
          </div>

          <div className="min-w-0">
            <span className="inline-block rounded-[7px] bg-[#EEF3FF] px-2.5 py-[3px] text-[10.5px] font-semibold uppercase tracking-[.09em] text-[#2F57E6]">
              LMT battery · e-bike
            </span>
            <h1 className="mb-1 mt-2 text-[clamp(22px,3.4vw,30px)] font-bold tracking-[-.01em] [text-wrap:balance]">
              VoltRide City Pro 48V
            </h1>
            <p className="text-[13.5px] text-[#6B7590]">
              NordCycle Mobility GmbH · Passport ID <b className="font-semibold tabular-nums text-[#2F57E6]">DPP-2027-PVX-0001</b>
            </p>
            <div className="mt-3 flex flex-wrap gap-2">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-[#E9F5EE] px-[11px] py-1 text-[11.5px] font-semibold text-[#0E7A4A]">✓ Verified record</span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-[#EEF3FF] px-[11px] py-1 text-[11.5px] font-semibold text-[#1E3C9A]">Status: Original</span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-[#F6F8FC] px-[11px] py-1 text-[11.5px] font-semibold text-[#6B7590]">Updated 21 Sep 2027</span>
            </div>
          </div>

          <div className="text-center max-[760px]:col-span-full max-[760px]:flex max-[760px]:items-center max-[760px]:gap-3.5 max-[760px]:text-left">
            <div className="h-[132px] w-[132px] rounded-[14px] bg-white p-2.5 shadow-[inset_0_0_0_1.5px_#E6EBF4] max-[760px]:h-[104px] max-[760px]:w-[104px]">
              <svg viewBox="0 0 25 25" shapeRendering="crispEdges" role="img" aria-label="QR code for this passport" className="block h-full w-full">
                <path d={QR_PATH} fill="#0E1A3A" />
              </svg>
            </div>
            <span className="mt-1.5 block text-[10.5px] tracking-[.04em] text-[#6B7590]">Scan the label on the battery</span>
          </div>
        </section>

        {/* key facts */}
        <section aria-label="Key figures" className="grid grid-cols-[repeat(auto-fit,minmax(160px,1fr))] gap-2.5">
          {FACTS.map(([bg, lab, v, unit]) => (
            <div key={lab} className={`rounded-2xl px-[15px] py-[13px] ${bg}`}>
              <span className="block text-[10px] font-semibold uppercase tracking-[.09em] text-[#8B93A8]">{lab}</span>
              <div className="mt-[3px] text-[23px] font-bold leading-[1.15] tabular-nums">
                {v} <small className="text-xs font-medium text-[#6B7590]">{unit}</small>
              </div>
            </div>
          ))}
        </section>

        {/* access tabs */}
        <div role="tablist" aria-label="Who can see what" className="flex gap-1.5 overflow-x-auto rounded-2xl bg-white p-1.5 shadow-[0_6px_20px_rgba(14,26,58,.05)]">
          {TABS.map((t, i) => {
            const selected = active === i;
            return (
              <button
                key={t.id}
                ref={(el) => (tabRefs.current[i] = el)}
                type="button"
                role="tab"
                id={`sp-tab-${t.id}`}
                aria-selected={selected}
                aria-controls={`sp-p-${t.id}`}
                tabIndex={focusIdx === i ? 0 : -1}
                onClick={() => setActive(i)}
                onKeyDown={(e) => onTabKey(e, i)}
                className={`flex flex-[1_0_auto] cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-[11px] px-3.5 py-2.5 text-[13px] font-semibold focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#2F57E6] ${
                  selected ? "bg-[#336BE1] text-white" : hoverIdx === i ? "bg-[rgba(51,107,225,.1)] text-[#3A4563]" : "text-[#3A4563]"
                }`}
              >
                <Ic n={t.icon} className="h-[15px] w-[15px]" />
                {t.label}
              </button>
            );
          })}
        </div>
        <p className="-mt-1.5 px-1 text-[12.5px] text-[#6B7590]" aria-live="polite">
          {active < 0 ? NOTE_IDLE : NOTES[active]}
        </p>

        {/* PUBLIC */}
        {active === 0 && (
          <div id="sp-p-public" role="tabpanel" aria-labelledby="sp-tab-public" className="sp-rise grid grid-cols-[repeat(2,minmax(0,1fr))] items-start gap-4 max-[760px]:grid-cols-1">
            <section className={CARD}>
              <SecHead icon="info" title="General information" desc="Who made the battery, what it is and where it came from." />
              <Rows rows={GENERAL} />
            </section>

            <section className={CARD}>
              <SecHead icon="box" title="Materials & composition" desc="What's inside the cells." />
              <Rows rows={MATERIALS} />
            </section>

            <section className={CARD}>
              <SecHead icon="leaf" title="Carbon footprint" desc="Emissions across the battery's life cycle, per kWh of capacity." />
              <div className="mb-3.5 flex items-center gap-4 rounded-2xl bg-[#EEF3FF] px-4 py-3.5">
                <div>
                  <div className="text-[32px] font-bold leading-none tabular-nums text-[#1E3C9A]">61.4</div>
                  <div className="mt-[3px] whitespace-nowrap text-xs text-[#6B7590]">kg CO₂e per kWh</div>
                </div>
                <div className="text-[13px] text-[#3A4563]">
                  About <b className="font-bold tabular-nums">41 kg CO₂e</b> for this 672 Wh battery. Performance class <b className="font-bold">B</b>.
                </div>
              </div>
              <div className="flex h-3.5 gap-0.5 overflow-hidden rounded-lg" aria-hidden="true">
                {STACK.map(([w, c]) => <i key={c} className="block h-full" style={{ width: w, background: c }} />)}
              </div>
              <div className="mt-3 grid grid-cols-[1fr_auto] gap-x-3 gap-y-1.5 text-[12.5px]">
                {STACK.map(([, c, label, val]) => (
                  <div key={label} className="contents">
                    <span className="flex items-center gap-2 text-[#3A4563]">
                      <i className="block h-2.5 w-2.5 flex-none rounded-[3px]" style={{ background: c }} />{label}
                    </span>
                    <b className="text-right font-semibold tabular-nums">{val}</b>
                  </div>
                ))}
              </div>
            </section>

            <section className={CARD}>
              <SecHead icon="cycle" title="Recycled & renewable content" desc="Share of material recovered from waste, by metal." />
              <Bar label="Cobalt" pct={16} />
              <Bar label="Lithium" pct={6} />
              <Bar label="Nickel" pct={9} />
              <Bar label="Renewable content" pct={3} />
            </section>

            <section className={CARD}>
              <SecHead icon="gauge" title="Performance & durability" desc="Rated values from the manufacturer, plus live condition." />
              <Bar label="State of health" pct={100} soh />
              <Rows rows={PERFORMANCE} className="mt-2" />
            </section>

            <section className={CARD}>
              <SecHead icon="shield" title="Due diligence & conformity" desc="How the raw materials were sourced, and the compliance paperwork." />
              <Rows rows={DILIGENCE} />
            </section>

            <section className={CARD}>
              <SecHead icon="bin" title="End of life" desc="What to do when the battery is worn out." />
              <Rows rows={END_OF_LIFE} />
            </section>

            <section className={CARD}>
              <SecHead icon="clock" title="Passport history" desc="Every change to this record is logged." />
              <ol className="relative mt-1.5 before:absolute before:bottom-2 before:left-[7px] before:top-2 before:w-0.5 before:bg-[#D5DDEB] before:content-['']">
                {HISTORY.map(([when, what], i) => (
                  <li
                    key={i}
                    className="relative pb-3.5 pl-7 text-[13.5px] last:pb-0 before:absolute before:left-0 before:top-[5px] before:h-4 before:w-4 before:rounded-full before:bg-[#0E7A4A] before:shadow-[0_0_0_4px_#fff] before:content-['']"
                  >
                    <time className="block text-[11.5px] font-semibold tracking-[.02em] text-[#2F57E6]">{when}</time>
                    {what}
                  </li>
                ))}
              </ol>
            </section>
          </div>
        )}

        {/* RESTRICTED LEVELS */}
        {(active === 1 || active === 2) && (() => {
          const L = LOCKED[active - 1];
          const id = TABS[active].id;
          return (
            <section id={`sp-p-${id}`} role="tabpanel" aria-labelledby={`sp-tab-${id}`} className="sp-rise rounded-[22px] bg-white p-[22px] shadow-[0_10px_32px_rgba(14,26,58,.06)]">
              <div className="flex items-center gap-3">
                <span className="grid h-10 w-10 flex-none place-items-center rounded-xl bg-[#FCF3DF] text-[#9A6A05]">
                  <Ic n="lock" className="h-5 w-5" />
                </span>
                <div>
                  <h2 className="text-lg font-bold tracking-[-.01em]">{L.title}</h2>
                  <p className="mt-0.5 text-[13px] text-[#6B7590]">{L.who}</p>
                </div>
              </div>
              <ul className="mt-3.5 grid grid-cols-[repeat(auto-fit,minmax(min(240px,100%),1fr))] gap-2.5">
                {L.items.map(([ic, text], i) => (
                  <li key={text} className="sp-li flex items-start gap-2.5 rounded-[14px] bg-[#F6F8FC] px-3.5 py-3 text-[13.5px] font-medium" style={{ animationDelay: `${i * 0.08}s` }}>
                    <Ic n={ic} className="mt-0.5 h-4 w-4 flex-none text-[#8B93A8]" />
                    {text}
                  </li>
                ))}
              </ul>
              <p className="mt-3.5 border-t border-[#E6EBF4] pt-3 text-[12.5px] text-[#6B7590]">{L.how}</p>
            </section>
          );
        })()}
      </main>

      <footer className="mx-auto flex max-w-[1080px] flex-wrap justify-between gap-x-[18px] gap-y-1.5 px-4 pb-8 text-xs text-[#6B7590]">
        <span><b className="font-semibold text-[#3A4563]">Provinyx</b> · Digital battery passport issued under EU Regulation 2023/1542, Annex XIII</span>
        <span>Sample passport · fictional data</span>
      </footer>
      </div>
      </div>

      {/* demo cursor + click ripples */}
      {ripples.map((r) => (
        <span
          key={r.id}
          aria-hidden="true"
          className="sp-ripple pointer-events-none fixed z-[49] h-5 w-5 rounded-full border-[3px] border-solid border-[#336BE1]"
          style={{ left: r.x, top: r.y, margin: "-10px 0 0 -10px" }}
        />
      ))}
      <div
        aria-hidden="true"
        className="pointer-events-none fixed left-0 top-0 z-50 h-[34px] w-[26px] [filter:drop-shadow(0_3px_5px_rgba(0,0,0,.3))]"
        style={{
          transform: `translate(${pos.x}px,${pos.y}px)`,
          opacity: cursorOn ? 1 : 0,
          transition: "transform .75s cubic-bezier(.65,0,.35,1), opacity .3s",
        }}
      >
        <svg
          width="26" height="34" viewBox="0 0 26 34"
          className="block"
          style={{ transition: "transform .12s", transform: press ? "scale(.86)" : "none", transformOrigin: "2px 2px" }}
        >
          <path d="M2 2 L2 27 L8.5 21 L13 31.5 L17.5 29.5 L13 19.3 L22 19.3 Z" fill="#111827" stroke="#fff" strokeWidth="2" strokeLinejoin="round" />
        </svg>
      </div>
    </div>,
    document.body
  );
}